export enum MonitoringViewModesEnum {
    MENTION = 'MENTION',
    DASHBOARD = 'DASHBOARD',
    SYNDICATE = 'SYNDICATE'
}
